const ARROW_BUTTON_HEIGHT = 28;
export const getArrowTopPositionInSlider = ({ pictureHeight, pictureSpace = 0, }) => Object.fromEntries(Object.entries(pictureHeight).map(([key, value]) => [
    key,
    `${value - ARROW_BUTTON_HEIGHT - pictureSpace}px`,
]));
//# sourceMappingURL=getArrowTopPositionInSlider.js.map